import { storeToRefs } from "pinia"
import { createRule } from "@regle/core"
import type { SaleItem } from "@/models/sale-item.model.ts"
import { useSaleItemStore } from "@/store/sale-items.store.ts"

export const uniqueSaleItemValidator = createRule({
  validator: (_value: unknown, saleItem: SaleItem) => {
    const saleItemStore = useSaleItemStore()
    const { saleItems } = storeToRefs(saleItemStore)

    if (!saleItem.name || !saleItem.unit) {
      return true
    }

    return !saleItems.value.some(
      (item) =>
        item.name.toLowerCase() === saleItem.name.toLowerCase() &&
        item.unit === saleItem.unit &&
        item.id !== saleItem.id
    )
  },
  message: "Er bestaat al een verkoopartikel met deze naam en eenheid"
})
